import { LogLevel } from '@lib/types';

export const LOG_LEVELS: Record<LogLevel, number> = {
  debug: 0,
  log: 1,
  info: 1,
  warn: 2,
  error: 3
};

export const isLogged = (msgLevel: LogLevel, logLevel: LogLevel) => {
  const msgLvl = LOG_LEVELS[msgLevel];
  const logLvl = LOG_LEVELS[logLevel];

  return msgLvl >= logLvl;
};
